// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"8a0f37fd","5540":"6ebfce7c","7193":"85731227"}[chunkId] + ".chunk.css";
};